import React, { Component } from 'react';
import ReactSelect from '../../../components/ReactSelect';
import { createProjects, createQuery, getCredits, getProjects, updateQuery } from './query';
import Loading from '../../../components/Loading';
import Message from '../../Message';

import { FREQUENCY_OPTIONS, PLATFORM_OPTIONS } from './utils';
import { COUNTRIES } from './countries';
import { LANGUAGES } from './languages';
import _ from 'lodash';
import AddNewProjectModal from './addNewProjectModal';
import { withTranslation } from 'react-i18next';
import { showPlatform } from '../PromptManager/keys';
import numeral from 'numeral';
import ProjectEditModal from '../projects/modal/EditProject/modal';
import ActivatePlanComponent from '../../ActivatePlanComponent';
import {
    getStoredCountryLanguage,
    resolveCountryLanguage,
    saveCountryLanguage,
} from '../../../helpers/aiTrackingCountryLanguage';

class AiTrackingAdd extends Component {
    constructor(props) {
        super();

        this.urlParams = new URLSearchParams(window.location.search);
        this.prompts = props.prompts ?? [];

        this.handleSelect = this.handleSelect.bind(this);
        this.handleSelectMulty = this.handleSelectMulty.bind(this);
        this.deleteMessage = this.deleteMessage.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.handleSelectCountry = this.handleSelectCountry.bind(this);
        this.calculateCredits = this.calculateCredits.bind(this);
        this.openAddNewProjectModal = this.openAddNewProjectModal.bind(this);
        this.closeAddNewProjectModal = this.closeAddNewProjectModal.bind(this);
        this.handleSelectProject = this.handleSelectProject.bind(this);
        this.onAddProject = this.onAddProject.bind(this);
        this.getProjectsData = this.getProjectsData.bind(this);
        this.showProjects = this.showProjects.bind(this);
        this.getBalance = this.getBalance.bind(this);
        this.onShowBalanceDetails = this.onShowBalanceDetails.bind(this);
        this.handleModeChange = this.handleModeChange.bind(this);
        this.updateProject = this.updateProject.bind(this);

        const isDark = JSON.parse(localStorage.getItem('dark-mode'));

        const userCountryLanguage = getStoredCountryLanguage();

        if (props.editMode) {
            this.state = {
                country: props.item.country,
                language: props.item.language,
                frequency: props.item.frequency,
                device: props.item.device,
                selectedItem: null,
                keywords: props.item.keyword || props.item.prompt,
                message: '',
                loading: false,
                platforms: props.item.platforms ?? [],
                errors: {},
                creditCalculation: 0,
                projects: [],
                selectedProject: props.defaultSelectedProject ?? props.item.project?.id ?? null,
                isOpenAddNeProjectModal: false,
                addProjectLoading: false,
                plan_credits: 0,
                available_credits: 0,
                total_credits: 0,
                add_on_credits: 0,
                used_credits: 0,
                balanceLoader: false,
                showBalanceDetails: false,
                isDark: !!isDark,
                // tags: props.item?.tags ?? [],
                tagInputValue: props.item?.tags?.length ? props.item.tags.join(',') : '',
            };
        } else {
            this.state = {
                country: userCountryLanguage?.country ?? '',
                language: userCountryLanguage?.language ?? '',
                frequency: 'weekly',
                device: 'desktop',
                selectedItem: null,
                keywords: this.prompts.join('\n'),
                message: '',
                loading: false,
                platforms: props.defaultPlatforms ?? [],
                errors: {},
                creditCalculation: 0,
                projects: [],
                selectedProject: props.defaultSelectedProject ?? null,
                isOpenAddNeProjectModal: false,
                addProjectLoading: false,
                plan_credits: 0,
                available_credits: 0,
                total_credits: 0,
                add_on_credits: 0,
                used_credits: 0,
                balanceLoader: false,
                showBalanceDetails: false,
                isDark: !!isDark,
                // tags: [],
                tagInputValue: '',
            };
        }
    }

    handleModeChange() {
        const isDark = JSON.parse(localStorage.getItem('dark-mode'));
        this.setState({ isDark });
    }

    onShowBalanceDetails() {
        this.setState((prevState) => ({
            showBalanceDetails: !prevState.showBalanceDetails,
        }));
    }

    async getProjectsData(selectedProject) {
        try {
            this.setState({
                projectLoader: true,
            });
            const response = await getProjects();
            const data = await response.json();
            const projects = data
                .filter((item) => !item.is_disabled)
                ?.map((item) => ({
                    label: item.name,
                    value: item.id,
                    own_domain: item.own_domain,
                    own_product_name: item.own_product_name,
                    country: item.country,
                    language: item.language,
                }));
            const nextSelectedProject =
                selectedProject ??
                this.props.defaultSelectedProject ??
                this.props.item?.project?.id ??
                null;

            this.setState({
                projectLoader: false,
                projects,
                selectedProject: nextSelectedProject,
                // The project may already be chosen for us (deep link, default project, prompt
                // being edited), so apply its country/language as soon as the list resolves it --
                // not only when the user picks one by hand. Skipped when nothing resolved, so a
                // refetch that clears the selection (e.g. right after adding a project) does not
                // throw away a country the user picked in the meantime.
                ...(nextSelectedProject
                    ? this.countryLanguageForProject(nextSelectedProject, projects)
                    : {}),
            });
        } catch (err) {
            console.log('err', err);
        }
    }

    async getBalance() {
        try {
            this.setState({
                balanceLoader: true,
            });
            const response = await getCredits();
            const data = await response.json();
            const plan_credits = data?.plan_credits;
            const total_credits = data?.total_credits;
            const add_on_credits = data?.add_on_credits;
            const available_credits = data?.available_credits;
            const used_credits = data?.used_credits;

            this.setState({
                plan_credits,
                total_credits,
                add_on_credits,
                used_credits,
                available_credits,
                balanceLoader: false,
            });
        } catch (err) {
            console.log('err', err);
        }
    }

    async componentDidMount() {
        document.addEventListener('changeMoodEvent', this.handleModeChange);
        this.getProjectsData();
        this.getBalance();
        this.notifyCanSubmit();
    }

    componentWillUnmount() {
        document.removeEventListener('changeMoodEvent', this.handleModeChange);
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            prevState.keywords !== this.state.keywords ||
            JSON.stringify(this.state.platforms) !== JSON.stringify(prevState.platforms) ||
            this.state.frequency !== prevState.frequency
        ) {
            this.calculateCredits();
        }

        this.notifyCanSubmit();
    }

    isNotEnoughCredits() {
        return (
            !this.state.balanceLoader && this.state.creditCalculation > this.state.available_credits
        );
    }

    /** The prompts actually typed into the box, blank lines and stray whitespace ignored. */
    promptLines() {
        return (this.state.keywords ?? '')
            .split('\n')
            .map((line) => line.trim())
            .filter(Boolean);
    }

    /**
     * Whether the box holds more prompts than the caller allows.
     *
     * Only callers that pass `maxPrompts` have a ceiling -- onboarding, which asks for a handful
     * to get tracking started rather than a whole plan. Everywhere else the form is unbounded,
     * as it has always been.
     */
    exceedsMaxPrompts() {
        return !!this.props.maxPrompts && this.promptLines().length > this.props.maxPrompts;
    }

    /** Whether the form is still missing something required (platforms, keywords, project, credits). */
    isSubmitDisabled() {
        return (
            (!this.props.editMode && !this.state.available_credits) ||
            this.state.loading ||
            this.isNotEnoughCredits() ||
            this.exceedsMaxPrompts() ||
            this.state.platforms.length === 0 ||
            !this.state.keywords ||
            !this.state.selectedProject
        );
    }

    /**
     * Tell the hosting modal whether the form can be submitted.
     *
     * In modal mode the real submit button is hidden and driven by the modal's footer button
     * through `submitButtonRef.click()`. A disabled button swallows that click silently, so
     * without this the footer button looks clickable but does nothing (most visibly when no
     * platform is selected). The flag is kept on an instance field rather than in state so
     * notifying never triggers another render.
     */
    notifyCanSubmit() {
        if (!this.props.onChangeCanSubmit) {
            return;
        }

        const canSubmit = !this.isSubmitDisabled();
        if (canSubmit === this.lastNotifiedCanSubmit) {
            return;
        }

        this.lastNotifiedCanSubmit = canSubmit;
        this.props.onChangeCanSubmit(canSubmit);
    }

    calculateCredits() {
        const keywordsCount =
            (this.state.keywords?.split('\n')?.filter((item) => item !== '')?.length || 0) *
            this.state.platforms.length;
        this.setState({
            creditCalculation: keywordsCount,
        });
    }

    onChange(e) {
        this.setState({
            [e.target.name]: e.target.value,
            errors: {},
        });
    }

    handleSelectCountry(data) {
        this.setState({ country: data.value, language: data.language, errors: {} });
    }

    handleSelect(value, name) {
        this.setState({ [name]: value, errors: {} });
    }

    handleSelectProject(value) {
        if (value === -1) {
            return;
        }

        this.setState({
            selectedProject: value,
            errors: {},
            ...this.countryLanguageForProject(value),
        });
    }

    /**
     * Partial state preselecting the country/language for `projectId`.
     *
     * Empty in edit mode, where the country/language selects are not rendered at all and the values
     * belong to the prompt being edited rather than to its project.
     */
    countryLanguageForProject(projectId, projects = this.state.projects) {
        if (this.props.editMode) {
            return {};
        }

        const project = projects.find((x) => x.value === projectId) ?? null;
        return resolveCountryLanguage(project);
    }

    handleSelectMulty(value) {
        const { platforms } = this.state;
        const values = platforms.includes(value)
            ? platforms.filter((item) => item !== value)
            : [...platforms, value];
        this.setState({ platforms: values, errors: {} });
    }

    deleteMessage() {
        this.setState({ message: '' });
    }

    openAddNewProjectModal() {
        this.setState({
            isOpenAddNeProjectModal: true,
        });
    }
    closeAddNewProjectModal() {
        this.setState({
            isOpenAddNeProjectModal: false,
        });
    }

    async onAddProject(name) {
        try {
            this.setState({
                addProjectLoading: true,
            });

            const body = {
                name,
                is_default: false,
            };

            await createProjects(body);
            this.getProjectsData();
            this.setState({
                addProjectLoading: false,
                isOpenAddNeProjectModal: false,
            });
        } catch (err) {
            this.setState({
                addProjectLoading: false,
                message: err?.message ?? this.props.t('global.something_went_wrong'),
            });
        }
    }

    async onSubmit(e) {
        try {
            e.preventDefault();

            // The submit button is already disabled for this, but a <form> still submits on
            // Enter in a text field. Nothing to report back: the message is on screen from the
            // moment the box goes over.
            if (this.exceedsMaxPrompts()) {
                return;
            }

            if (
                !this.props.editMode &&
                this.state.creditCalculation > this.state.available_credits
            ) {
                return this.setState({
                    message: this.props.t('ai_tracking.add_keyword.error_message', {
                        available_credits: this.state.available_credits,
                        creditCalculation: this.state.creditCalculation,
                    }),
                    message_tags: 'error',
                });
            }

            let body = {
                country: this.state.country,
                language: this.state.language,
                frequency: this.state.frequency,
                device: this.state.device,
                platforms: this.state.platforms,
                project: this.state.selectedProject,
                tags: this.state.tagInputValue
                    ? this.state.tagInputValue?.split(',').map((item) => item.trim()) || []
                    : [],
                prompts: this.state.keywords
                    ? this.state.keywords
                          .split('\n')
                          .map((item) => item.trim())
                          .filter((item) => item)
                    : null,
            };

            if (this.props.editMode) {
                body = {
                    frequency: this.state.frequency,
                    device: this.state.device,
                    platforms: this.state.platforms,
                    tags: this.state.tagInputValue?.trim()
                        ? this.state.tagInputValue?.split(',').map((item) => item.trim()) || []
                        : [],
                };
            }

            const errors = {};
            for (let key in body) {
                const item = body[key];
                if ((!item || (Array.isArray(item) && !item.length)) && key !== 'tags') {
                    errors[key] = this.props.t('global.this_field_required');
                }
            }

            if (!_.isEmpty(errors)) {
                return this.setState({
                    errors,
                });
            }

            if (!this.props.editMode) {
                saveCountryLanguage({
                    country: this.state.country,
                    language: this.state.language,
                });
            }
            this.setState({
                loading: true,
                error_message: null,
                existing_prompts: [],
            });

            this.props.onChangeLoading?.(true);

            const query = async () =>
                this.props.editMode
                    ? await updateQuery(this.props.item.id, body)
                    : await createQuery(body);
            const res = await query(body);

            if (res.status === 200) {
                const data = await res?.json();

                const successMessage = {
                    message:
                        'Prompt(s) added successfully. Your Prompts Tracking Results will be available in few minutes!',
                    message_type: 'alert-success',
                    link: `/ai-tracking/project/${this.state.selectedProject}/`,
                    link_name: 'View Results',
                };
                let messages = [successMessage];

                if (data.ignored_prompts) {
                    if (body.prompts.length === data.ignored_prompts.length) {
                        this.setState({
                            loading: false,
                            error_message:
                                "All this prompts you have already added before, so we didn't add them again. Please check the list of existing prompts.",
                        });
                        if (this.props.modalBodyRef?.current) {
                            const el = this.props.modalBodyRef?.current;
                            setTimeout(() => {
                                el.scrollTop = el.scrollHeight;
                            }, 100);
                        }
                        return;
                    }

                    if (data.ignored_prompts.length)
                        messages.push({
                            message: `${data.ignored_prompts.length} prompt(s) were ignored as they are similar to existing prompts.`,
                            message_type: 'alert-info',
                        });
                }
                if (this.props.onAdded) {
                    // The caller stays on screen and says its own piece, so the message meant
                    // for the page we are not navigating to is never stashed.
                    this.props.onChangeLoading?.(false);
                    this.setState({ loading: false });
                    this.props.onAdded(data, body);
                    return;
                }

                sessionStorage.setItem('ai_tracking_message', JSON.stringify(messages));
                if (this.props.editMode) {
                    this.props.onSubmit?.();
                } else {
                    window.location.href = '/ai-tracking/';
                }
            } else {
                const data = await res?.json();
                this.props.onChangeLoading?.(false);
                this.setState({
                    loading: false,
                    error_message: data?.detail ?? this.props.t('global.something_went_wrong'),
                    existing_prompts: data?.extra?.existing_prompts ?? [],
                });
                if (this.props.modalBodyRef?.current) {
                    const el = this.props.modalBodyRef?.current;
                    setTimeout(() => {
                        el.scrollTop = el.scrollHeight;
                    }, 100);
                }
            }
        } catch (err) {
            this.props.onChangeLoading?.(false);
            this.setState({
                loading: false,
                message: err?.message ?? this.props.t('global.something_went_wrong'),
                message_tags: 'error',
                error_message: err?.message ?? this.props.t('global.something_went_wrong'),
            });
        }
    }

    showProjects() {
        const options =
            this.state.projects?.map((item) => ({
                label: (
                    <div className="d-flex align-items-center gap-8">
                        <strong>{item.label}</strong>{' '}
                        {item.own_product_name && (
                            <div className="project-domain-brand">
                                {item.own_product_name} / {item.own_domain}
                            </div>
                        )}
                    </div>
                ),
                value: item.value,
            })) ?? [];

        const addProjectBtn = (
            <>
                {this.state.projectLoader && (
                    <div className="d-flex justify-content-center my-10">
                        <Loading />
                    </div>
                )}
                <div className="ai-custom-select-option">
                    <button onClick={this.openAddNewProjectModal}>
                        {this.props.t('ai_tracking.add_keyword.add_new')}
                        <i className="icon-plus" />
                    </button>
                </div>
            </>
        );

        return [
            ...options,
            {
                label: addProjectBtn,
                value: -1,
            },
        ];
    }

    updateProject(key, id, data) {
        this.getProjectsData(data?.id);
        this.setState({
            isOpenAddNeProjectModal: false,
        });
    }

    render() {
        const { t } = this.props;
        let CUSTOM_PLATFORM_OPTIONS = PLATFORM_OPTIONS;

        const PROJECTS_OPTIONS = this.showProjects();

        const isNotEnoughtCredits = this.isNotEnoughCredits();

        const frequency_options = FREQUENCY_OPTIONS(t);

        const optionStyles = (state) => {
            return {
                fontFamily: 'Inter',
                fontSize: '16px',
                fontStyle: 'normal',
                fontWeight: 500,
                lineHeight: '24px' /* 150% */,
                padding: state.value === -1 ? '0px' : '12px',
                borderTop: state.value === -1 ? '1px solid #eaecf0' : 'none',
                '&:hover': {
                    border: '1px solid rgba(51, 177, 165, 0.40)',
                    borderWidth: state.value === -1 ? '1px 0 0 0' : '1px 0 1px 0',
                    background: state.value === -1 ? 'unset' : 'rgba(51, 177, 165, 0.20)',
                    cursor: 'pointer',
                },
            };
        };

        const themeStyles = { borderRadius: 8 };

        const controlStyles = this.props.isModal
            ? {
                  backgroundColor: this.state.isDark ? '#2a3143' : '#f5f6f9',
                  border: 'none',
                  minWidth: 0,
                  color: '#101828',
                  fontFamily: 'Inter',
                  fontSize: '14px',
                  fontStyle: 'normal',
                  fontWeight: 500,
                  lineHeight: '20px',
              }
            : {
                  color: '#101828',
                  fontFamily: 'Inter',
                  fontSize: '14px',
                  fontStyle: 'normal',
                  fontWeight: 500,
                  lineHeight: '20px',
              };

        const disableSubmitButton = this.isSubmitDisabled();

        return (
            <>
                <div className="card rounded-main ai-tracking-component create-ai-tracking-card">
                    <div className="card-body pt-0">
                        <div>
                            <div>
                                <div>
                                    <form onSubmit={this.onSubmit}>
                                        <div className="d-flex gap-24 justify-content-between">
                                            <div className="w-100">
                                                {!this.props.editMode && (
                                                    <div className="py-8">
                                                        <ReactSelect
                                                            options={PROJECTS_OPTIONS}
                                                            value={
                                                                PROJECTS_OPTIONS.find(
                                                                    (x) =>
                                                                        x.value ===
                                                                        this.state.selectedProject,
                                                                ) ?? null
                                                            }
                                                            labelClassname={
                                                                'ai-tracking-create-label'
                                                            }
                                                            label={
                                                                <div>
                                                                    {`${t(
                                                                        'ai_tracking.add_keyword.project',
                                                                    )}`}{' '}
                                                                    <span className="text-danger">
                                                                        *
                                                                    </span>
                                                                </div>
                                                            }
                                                            placeholder={t(
                                                                'ai_tracking.add_keyword.project',
                                                            )}
                                                            onChange={this.handleSelectProject}
                                                            blurInputOnSelect={true}
                                                            classname="mr-0"
                                                            disabled={
                                                                this.state.loading ||
                                                                this.state.projectLoader
                                                            }
                                                            isSearchable
                                                            themeStyles={themeStyles}
                                                            components={{
                                                                IndicatorSeparator: () => null,
                                                            }}
                                                            controlStyles={controlStyles}
                                                            optionsStyles={optionStyles}
                                                        />
                                                        {this.state.errors['project'] && (
                                                            <div className="error-message">
                                                                {this.state.errors['project']}
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                                <div className="py-8">
                                                    <label className="ai-tracking-create-label">
                                                        {t(
                                                            'ai_tracking.add_keyword.choose_platforms',
                                                        )}{' '}
                                                        <span className="text-danger">*</span>{' '}
                                                        <br />
                                                    </label>
                                                    <div className="ai-tracking-platforms">
                                                        {CUSTOM_PLATFORM_OPTIONS?.map((item) => (
                                                            <div
                                                                className={`ai-tracking-checkbox-input ${
                                                                    this.state.platforms.includes(
                                                                        item.value,
                                                                    )
                                                                        ? 'active'
                                                                        : ''
                                                                }`}
                                                                key={item.value}
                                                            >
                                                                <input
                                                                    id={item.value}
                                                                    type="checkbox"
                                                                    onChange={() =>
                                                                        this.handleSelectMulty(
                                                                            item?.value,
                                                                        )
                                                                    }
                                                                    checked={this.state.platforms.includes(
                                                                        item.value,
                                                                    )}
                                                                />
                                                                <label htmlFor={item.value}>
                                                                    {showPlatform(item.value)}
                                                                    {item.label}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                    {this.state.errors['platforms'] && (
                                                        <div className="error-message">
                                                            {t(
                                                                'ai_tracking.add_keyword.select_platform_message',
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                                {!this.props.editMode && (
                                                    <div className="py-8">
                                                        <label className="ai-tracking-create-label">
                                                            {t(
                                                                'ai_tracking.add_keyword.add_prompts',
                                                            )}{' '}
                                                            <span className="text-danger">*</span>{' '}
                                                            <br />
                                                            <small>
                                                                {this.props.maxPrompts
                                                                    ? t(
                                                                          'ai_tracking.add_keyword.max_prompts_hint',
                                                                          {
                                                                              count: this.props
                                                                                  .maxPrompts,
                                                                          },
                                                                      )
                                                                    : t(
                                                                          'ai_tracking.add_keyword.keywords_subtitle',
                                                                      )}
                                                            </small>
                                                        </label>
                                                        <textarea
                                                            type="text"
                                                            name="keywords"
                                                            className="entity-input"
                                                            value={this.state.keywords}
                                                            onChange={this.onChange}
                                                            disabled={this.state.loading}
                                                            style={{
                                                                minHeight: '100px',
                                                            }}
                                                        ></textarea>

                                                        {/* Said as soon as the box goes over,
                                                            not held back until a submit that is
                                                            already blocked. */}
                                                        {this.exceedsMaxPrompts() && (
                                                            <div className="error-message">
                                                                {t(
                                                                    'ai_tracking.add_keyword.max_prompts_error',
                                                                    {
                                                                        count: this.props
                                                                            .maxPrompts,
                                                                        entered:
                                                                            this.promptLines()
                                                                                .length,
                                                                    },
                                                                )}
                                                            </div>
                                                        )}

                                                        {this.state.errors['prompts'] &&
                                                            !this.exceedsMaxPrompts() && (
                                                                <div className="error-message">
                                                                    {this.state.errors['prompts']}
                                                                </div>
                                                            )}
                                                    </div>
                                                )}
                                                <div
                                                    className={`py-8 ai-tracking-selects ${
                                                        this.props.editMode ? 'edit-mode' : ''
                                                    }`}
                                                >
                                                    <div className="ai-tracking-select-item-with-icon">
                                                        <ReactSelect
                                                            options={frequency_options}
                                                            value={frequency_options.find(
                                                                (x) =>
                                                                    x.value ===
                                                                    this.state.frequency,
                                                            )}
                                                            labelClassname={
                                                                'ai-tracking-create-label'
                                                            }
                                                            label={
                                                                <div>
                                                                    {`${t(
                                                                        'ai_tracking.add_keyword.frequency',
                                                                    )}`}{' '}
                                                                    <span className="text-danger">
                                                                        *
                                                                    </span>
                                                                </div>
                                                            }
                                                            placeholder={t(
                                                                'ai_tracking.add_keyword.frequency',
                                                            )}
                                                            onChange={(e) =>
                                                                this.handleSelect(e, 'frequency')
                                                            }
                                                            blurInputOnSelect={true}
                                                            classname="mr-0"
                                                            disabled={this.state.loading}
                                                            isSearchable
                                                            themeStyles={themeStyles}
                                                            components={{
                                                                IndicatorSeparator: () => null,
                                                            }}
                                                            controlStyles={{
                                                                ...controlStyles,
                                                                paddingLeft: '27px',
                                                            }}
                                                            optionsStyles={optionStyles}
                                                        />
                                                        {this.state.errors['frequency'] && (
                                                            <div className="error-message">
                                                                {this.state.errors['frequency']}
                                                            </div>
                                                        )}
                                                        <img src="/static/img/calendar.svg" />
                                                    </div>
                                                    {!this.props.editMode && (
                                                        <>
                                                            <div>
                                                                <ReactSelect
                                                                    options={COUNTRIES}
                                                                    labelClassname={
                                                                        'ai-tracking-create-label'
                                                                    }
                                                                    value={COUNTRIES.find(
                                                                        (x) =>
                                                                            x.value ===
                                                                            this.state.country,
                                                                    )}
                                                                    label={
                                                                        <div>
                                                                            {`${t(
                                                                                'ai_tracking.add_keyword.country',
                                                                            )}`}{' '}
                                                                            <span className="text-danger">
                                                                                *
                                                                            </span>
                                                                        </div>
                                                                    }
                                                                    placeholder={t(
                                                                        'ai_tracking.add_keyword.country',
                                                                    )}
                                                                    customeOnChange={
                                                                        this.handleSelectCountry
                                                                    }
                                                                    blurInputOnSelect={true}
                                                                    classname="mr-0"
                                                                    disabled={this.state.loading}
                                                                    isSearchable
                                                                    themeStyles={themeStyles}
                                                                    components={{
                                                                        IndicatorSeparator: () =>
                                                                            null,
                                                                    }}
                                                                    controlStyles={controlStyles}
                                                                    optionsStyles={optionStyles}
                                                                />
                                                                {this.state.errors['country'] && (
                                                                    <div className="error-message">
                                                                        {
                                                                            this.state.errors[
                                                                                'country'
                                                                            ]
                                                                        }
                                                                    </div>
                                                                )}
                                                            </div>

                                                            <div>
                                                                <ReactSelect
                                                                    options={LANGUAGES}
                                                                    value={LANGUAGES.find(
                                                                        (x) =>
                                                                            x.value ===
                                                                            this.state.language,
                                                                    )}
                                                                    labelClassname={
                                                                        'ai-tracking-create-label'
                                                                    }
                                                                    label={
                                                                        <div>
                                                                            {`${t(
                                                                                'ai_tracking.add_keyword.language',
                                                                            )}`}{' '}
                                                                            <span className="text-danger">
                                                                                *
                                                                            </span>
                                                                        </div>
                                                                    }
                                                                    placeholder={t(
                                                                        'ai_tracking.add_keyword.language',
                                                                    )}
                                                                    onChange={(e) =>
                                                                        this.handleSelect(
                                                                            e,
                                                                            'language',
                                                                        )
                                                                    }
                                                                    blurInputOnSelect={true}
                                                                    classname="mr-0"
                                                                    disabled={this.state.loading}
                                                                    isSearchable
                                                                    themeStyles={themeStyles}
                                                                    components={{
                                                                        IndicatorSeparator: () =>
                                                                            null,
                                                                    }}
                                                                    controlStyles={controlStyles}
                                                                    optionsStyles={optionStyles}
                                                                />
                                                                {this.state.errors['language'] && (
                                                                    <div className="error-message">
                                                                        {
                                                                            this.state.errors[
                                                                                'language'
                                                                            ]
                                                                        }
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                                <div className="ai-tracking-component-tags-input py-8">
                                                    <div className="w-100">
                                                        <label className="ai-tracking-create-label">
                                                            {t('ai_tracking.add_keyword.add_tags')}{' '}
                                                            <br />
                                                            <small>
                                                                {t(
                                                                    'ai_tracking.add_keyword.add_tags_description',
                                                                )}
                                                            </small>
                                                        </label>
                                                        <input
                                                            className="form-control"
                                                            name="tagInputValue"
                                                            value={this.state.tagInputValue}
                                                            onChange={this.onChange}
                                                        />
                                                    </div>
                                                </div>
                                                {this.state.errors['tag'] && (
                                                    <div className="error-message">
                                                        {this.state.errors['tag']}
                                                    </div>
                                                )}
                                                {this.state.errors['tags'] && (
                                                    <div className="error-message">
                                                        {this.state.errors['tags']}
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        <div className="d-flex gap-10 align-items-center mt-10">
                                            {!this.props.editMode && (
                                                <div
                                                    className={`ai-tracking-component-cost-box ${
                                                        isNotEnoughtCredits ? 'warning' : ''
                                                    }`}
                                                >
                                                    <img src="/static/img/gold.svg" />
                                                    {t(
                                                        'ai_tracking.add_keyword.credits_information',
                                                    )}
                                                    <strong>
                                                        {t(
                                                            'ai_tracking.add_keyword.credits_information_cost',
                                                            {
                                                                credit_calculation:
                                                                    this.state.creditCalculation,
                                                            },
                                                        )}
                                                    </strong>
                                                    {isNotEnoughtCredits ? (
                                                        t(
                                                            'ai_tracking.add_keyword.not_have_enought_credits',
                                                        )
                                                    ) : (
                                                        <span>
                                                            {t(
                                                                'ai_tracking.add_keyword.balance_after_running',
                                                            )}{' '}
                                                            <strong>
                                                                {t(
                                                                    'ai_tracking.add_keyword.balance_after_running_amount',
                                                                    {
                                                                        after_running_value:
                                                                            this.state
                                                                                .available_credits -
                                                                            this.state
                                                                                .creditCalculation,
                                                                    },
                                                                )}
                                                            </strong>
                                                        </span>
                                                    )}{' '}
                                                    {window.user_permissions
                                                        ?.subscription_status === 'trialing' && (
                                                        <span className="mr-6">
                                                            {t(
                                                                'ai_tracking.add_keyword.balance_for_trial',
                                                            )}
                                                        </span>
                                                    )}
                                                    {window.user_permissions
                                                        ?.subscription_status === 'trialing' ? (
                                                        <ActivatePlanComponent btn_class="ai_tracking_activate_btn" />
                                                    ) : (
                                                        <a href="/tools/add-ons/?part=prompt_tracking_credits">
                                                            {t(
                                                                'ai_tracking.add_keyword.purchase_more',
                                                            )}
                                                        </a>
                                                    )}
                                                </div>
                                            )}
                                            <button
                                                className="button button-filled button-primary width-sm btn align-items-center justify-content-center"
                                                ref={
                                                    this.props.editMode || this.props.isModal
                                                        ? this.props.submitButtonRef
                                                        : null
                                                }
                                                disabled={disableSubmitButton}
                                                style={{
                                                    display:
                                                        this.props.editMode || this.props.isModal
                                                            ? 'none'
                                                            : 'flex',
                                                }}
                                            >
                                                {t('ai_tracking.add_keyword.submit')}
                                            </button>
                                        </div>
                                    </form>
                                    {this.state.error_message && (
                                        <div className="error-message mt-10">
                                            {this.state.error_message}
                                            {this.state.existing_prompts?.length > 0 && (
                                                <div className="existing-prompts">
                                                    Prompts:
                                                    {this.state.existing_prompts.map(
                                                        (prompt, index) => (
                                                            <div key={index}>{prompt}</div>
                                                        ),
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                    {!this.props.editMode &&
                                        !this.props.isModal &&
                                        this.state.loading && <Loading padding="15px 0 0" />}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {!this.props.editMode && !this.props.isModal && (
                    <div className="card rounded-main ai-tracking-component mt-20 ai-tracking-balance-card">
                        <div className="ai-tracking-balance-container">
                            <div
                                className="ai-tracking-balance-container-header"
                                onClick={this.onShowBalanceDetails}
                            >
                                <div className="d-flex gap-8 align-items-center">
                                    <img src="/static/img/gold.svg" />
                                    {t('ai_tracking.add_keyword.your_credits')}
                                </div>
                                <button
                                    className={
                                        'ai-tracking-balance-container-header-icon ' +
                                        (this.state.showBalanceDetails ? 'active' : '')
                                    }
                                >
                                    <i className="icon-fi_chevron-down" />
                                </button>
                            </div>
                            <div
                                className={`ai-tracking-balance-container-body ${
                                    this.state.showBalanceDetails ? 'show' : ''
                                }`}
                            >
                                <div className="d-flex flex-wrap">
                                    <div className="ai-tracking-balance-item w-50">
                                        <div className="ai-tracking-balance-item-label">
                                            {t('ai_tracking.add_keyword.available_credits')}
                                        </div>
                                        <div className="ai-tracking-balance-item-number">
                                            {' '}
                                            {numeral(
                                                window?.user_permissions?.ai_tracking_credits
                                                    ?.total -
                                                    window?.user_permissions?.used
                                                        ?.ai_tracking_credits,
                                            ).format('0,0') ?? 0}
                                        </div>
                                    </div>
                                    <div className="ai-tracking-balance-item border-left w-50">
                                        <div className="ai-tracking-balance-item-label">
                                            {t('ai_tracking.add_keyword.used_credits')}
                                        </div>
                                        <div className="ai-tracking-balance-item-number">
                                            {' '}
                                            {numeral(
                                                window?.user_permissions?.used?.ai_tracking_credits,
                                            ).format('0,0') ?? 0}
                                        </div>
                                    </div>
                                </div>

                                <div className="ai-tracking-balance-item">
                                    <div className="ai-tracking-balance-item-label">
                                        {t('ai_tracking.add_keyword.plan_credits')}
                                    </div>
                                    <div className="ai-tracking-balance-item-number">
                                        {' '}
                                        {numeral(
                                            window?.user_permissions?.ai_tracking_credits?.plan,
                                        ).format('0,0') ?? 0}
                                    </div>
                                </div>
                                <div className="ai-tracking-balance-item">
                                    <div className="ai-tracking-balance-item-label">
                                        {t('ai_tracking.add_keyword.add_on_credits')}
                                    </div>
                                    <div className="ai-tracking-balance-item-number">
                                        {' '}
                                        {numeral(
                                            window?.user_permissions?.ai_tracking_credits?.addon,
                                        ).format('0,0') ?? 0}
                                    </div>
                                </div>

                                <div className="ai-tracking-balance-item total-credits">
                                    <div className="ai-tracking-balance-item-label">
                                        {t('ai_tracking.add_keyword.total_credits')}
                                    </div>
                                    <div className="ai-tracking-balance-item-number">
                                        {' '}
                                        {numeral(
                                            window?.user_permissions?.ai_tracking_credits?.total,
                                        ).format('0,0') ?? 0}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {this.state.message && (
                    <div className="messages">
                        <Message
                            message_tags={this.state.message_tags ?? 'error'}
                            message={this.state.message}
                            deleteMessage={this.deleteMessage}
                        />
                    </div>
                )}
                {this.state.isOpenAddNeProjectModal && (
                    <ProjectEditModal
                        isOpen={this.state.isOpenAddNeProjectModal}
                        onClose={this.closeAddNewProjectModal}
                        isCreate
                        updateData={this.updateProject}
                    />
                )}
                <AddNewProjectModal
                    isOpen={this.state.isOpenAddNeProjectModal}
                    onClose={this.closeAddNewProjectModal}
                    onSubmit={this.onAddProject}
                    loading={this.state.addProjectLoading}
                />
            </>
        );
    }
}

export default withTranslation()(AiTrackingAdd);
